import React, { useEffect } from 'react';
import { Form, InputNumber, Select, Button, Row, Col, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { putData } from '../../actions/developer';

const { Option } = Select;

const RuleTriggerTimeForm = ({ data, reload }) => {
    const [form] = Form.useForm();
    const [edit, setEdit] = React.useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (data) {
            if (!data.scheduleTime) {
                setEdit(true);
            }
            form.setFieldsValue({
                scheduleTime: data.scheduleTime,
                scheduleTimeUnit: data.scheduleTimeUnit,
            });
        }
    }, [data]);

    const onFinish = async (values) => {
        console.log('Form Values:', values);

        const resData = await dispatch(putData(`/work-flow-action/${data?._id}`, {
            ...values,
            actionType: 'Scheduled',
            scheduleStatus: 'active',
        }));

        if (resData) {
            setEdit(false);
            reload();
        }

    };

    return (
        <div className='mb-2'>
            {data.scheduleTime > 0 && <div className="text-sm font-semibold mb-2 mt-2 text-blue-600 cursor-pointer" onClick={(e) => setEdit(true)}>Execute {data?.scheduleTime} {data?.scheduleTimeUnit} After Rule Trigger Time</div>}
            {edit && <div>
                <Form
                    form={form}
                    layout="inline"
                    onFinish={onFinish}
                    className="w-full flex justify-between items-center flex-col"
                >
                    <Row className="text-sm">
                        <Col span={4} className='flex items-center'>
                            <span className="text-sm">Execute</span>
                        </Col>
                        <Col span={6} className='flex items-center flex-col'>

                            <Form.Item name="scheduleTime" rules={[{ required: true, message: 'Required' }]}>
                                <InputNumber min={1} maxLength={3} className="w-10" />
                            </Form.Item>
                        </Col>
                        <Col span={6} className='flex items-center flex-col'>
                            <Form.Item name="scheduleTimeUnit" rules={[{ required: true, message: 'Required' }]}>
                                <Select className="w-28">
                                    {['minutes', 'hours', 'days', 'weeks', 'months', 'years', 'am', 'pm'].map((ele, index) => <Option key={index} value={ele}>{ele}</Option>)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8} className='flex items-center'>
                            <span className="text-sm">Rule Trigger Time</span>
                        </Col>
                    </Row>
                </Form>
                <Space direction='horizontal' className="w-full flex justify-end mt-2">
                    <Button type="default" onClick={() => setEdit(false)} >
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
                        Save
                    </Button>
                </Space>
            </div>}
        </div>
    );
};

export default RuleTriggerTimeForm;
